import { ColumnDef } from "@tanstack/react-table"
import { Button, Menu } from "antd"
import Tooltip from "components-old/Tooltip"
import { ArrowTurnBackwardIcon, ColumnInsertIcon, Layout2ColumnIcon, SlidersVerticalIcon } from "components-old/icons"
import SearchDrop from "components-old/ui/SearchDrop"
import { isAldeia } from "hooks/useAldeia"

export interface ColumnsDropdownProps<T> {
  visibleColumns: string[]
  setVisibleColumns: (value: string[]) => void
  columns: ColumnDef<T>[]
  defaultColumns: string[]
  // localStorageKey: string
}

function ColumnsDropdown<T>(props: ColumnsDropdownProps<T>) {
  // const option = props.columns.find((option) => option.value === props.selected)

  return (
    <SearchDrop
      persistent
      title={
        <div>
          <Tooltip title="Resetar" mouseEnterDelay={0}>
            <Button
              icon={
                // <i
                //   className="far fa-undo-alt"
                //   style={{
                //     fontSize: 12,
                //   }}
                // />
                <ArrowTurnBackwardIcon />
              }
              type="text"
              size="small"
              style={{
                position: "absolute",
                right: 12,
                top: 12,
                borderRadius: 8,
              }}
              onClick={() => {
                props.setVisibleColumns(props.defaultColumns)
              }}
            />
          </Tooltip>
          Colunas
        </div>
      }
      options={[
        ...props.columns.map((column) => {
          let title = typeof column?.header === "string" ? column?.header : ""
          if (!title) {
            title = typeof column?.header === "function" ? (column?.header as any)?.() : ((column?.meta as any)?.title ?? "")
          }
          return {
            searchValue: title,
            key: column?.id,
            node: (
              <Menu.Item
                key={column?.id}
                icon={
                  props.visibleColumns.includes(column?.id!) ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path
                        fill="var(--primary)"
                        d="M12 1.999c5.524 0 10.002 4.478 10.002 10.002c0 5.523-4.478 10.001-10.002 10.001c-5.524 0-10.002-4.478-10.002-10.001C1.998 6.477 6.476 1.999 12 1.999Zm0 1.5a8.502 8.502 0 1 0 0 17.003A8.502 8.502 0 0 0 12 3.5Zm-.004 2.5a5.998 5.998 0 1 1 0 11.996a5.998 5.998 0 0 1 0-11.996Z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 32 32"
                      style={{
                        opacity: 0.3,
                      }}
                    >
                      <path
                        fill="currentColor"
                        d="M7.7 4.7a14.7 14.7 0 0 0-3 3.1L6.3 9a13.26 13.26 0 0 1 2.6-2.7zm-3.1 7.6l-1.9-.6A12.51 12.51 0 0 0 2 16h2a11.48 11.48 0 0 1 .6-3.7zm-1.9 8.1a14.4 14.4 0 0 0 2 3.9l1.6-1.2a12.89 12.89 0 0 1-1.7-3.3zm5.1 6.9a14.4 14.4 0 0 0 3.9 2l.6-1.9A12.89 12.89 0 0 1 9 25.7zm3.9-24.6l.6 1.9A11.48 11.48 0 0 1 16 4V2a12.51 12.51 0 0 0-4.3.7zm12.5 24.6a15.18 15.18 0 0 0 3.1-3.1L25.7 23a11.53 11.53 0 0 1-2.7 2.7zm3.2-7.6l1.9.6A15.47 15.47 0 0 0 30 16h-2a11.48 11.48 0 0 1-.6 3.7zm1.8-8.1a14.4 14.4 0 0 0-2-3.9l-1.6 1.2a12.89 12.89 0 0 1 1.7 3.3zm-5.1-7a14.4 14.4 0 0 0-3.9-2l-.6 1.9a12.89 12.89 0 0 1 3.3 1.7zm-3.8 24.7l-.6-1.9a11.48 11.48 0 0 1-3.7.6v2a21.42 21.42 0 0 0 4.3-.7z"
                      />
                    </svg>
                  )
                }
                onClick={(e) => {
                  e?.domEvent.stopPropagation()
                  e?.domEvent.preventDefault()
                  props.visibleColumns.includes(column?.id!)
                    ? props.setVisibleColumns(props.visibleColumns.filter((c) => c !== column?.id!))
                    : props.setVisibleColumns([...props.visibleColumns, column?.id!])
                }}
              >
                {title}
              </Menu.Item>
            ),
          }
        }),
      ]}
      pure
    >
      <Tooltip title="Colunas visíveis" mouseEnterDelay={0}>
        {isAldeia ? (
          // <Button icon={<IconMaterialSymbolsLightViewColumn2 className="!size-4" />} className="rounded-xl">

          <Button className="rounded-xl pr-1.5">
            Colunas
            <i className="fas fa-caret-down text-xs ml-2" />{" "}
          </Button>
        ) : (
          <Button type="text" icon={<Layout2ColumnIcon />} className="rounded-xl" />
        )}
      </Tooltip>
    </SearchDrop>
  )
}

export default ColumnsDropdown
